const headerUserScrolling = () => {
    if (window.location.pathname === '/') {
        const events = ['load', 'scroll', 'resize'];
        events.forEach((event) => {
            window.addEventListener(event, () => {
                const scrollAmount = window.scrollY;
                if (scrollAmount > 1) {
                    document.body.classList.add('homepage-scrolled');
                }
                else {
                    document.body.classList.remove('homepage-scrolled');
                }
            });
        });
    }
};
export { headerUserScrolling };
